function e(e){return e.replace(/([a-z])([A-Z])/g,"$1-$2").replace(/[\s_]+/g,"-").toLowerCase()}function r(e){return`${e.charAt(0).toUpperCase()}${e.slice(1)}`}export{r as capitalizeFirstLetter,e as kebabCase};
